// extracted by mini-css-extract-plugin
export default {"editButton":"undoPayrollCalculation_editButton__PEP5l","TableBody":"undoPayrollCalculation_TableBody__KzP4N","StopButton":"undoPayrollCalculation_StopButton__gx8cO"};